<script setup lang="ts">
/* eslint-env vue/setup-compiler-macros */
</script>

<template>
    <span class="empty-value-display">—</span>
</template>

<style lang="scss" scoped>
.empty-value-display {
    color: rgba($black-color, 0.35);
}
</style>